import { render, staticRenderFns } from "./AppsList.vue?vue&type=template&id=524e486c&scoped=true&"
import script from "./AppsList.vue?vue&type=script&lang=js&"
export * from "./AppsList.vue?vue&type=script&lang=js&"
import style0 from "./AppsList.vue?vue&type=style&index=0&id=524e486c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524e486c",
  null
  
)

export default component.exports